/**
 * 可配置化的页面信息
 * 要迁移到货源系统
 */

import { getActConfig } from '@/api/index';
import { IKeyValuePair } from '@/types';
import { TActConf, TConfigItem } from '@/types/api-type';
import { ConfigType, IPageInfo } from '@/types/config-type';
import { parseStrWitchObj } from '@/utils';
import qs from 'query-string';

let confInfo: TActConf = [];

export async function getPageInfoById(confId: string, adtag: string, confType: ConfigType): Promise<IPageInfo> {
  if (!confInfo.length) {
    confInfo = await getActConfig(confType);
  }

  console.log('== pageInfo ==', confInfo);

  // 获取业务信息
  const business = confInfo?.find((item: TConfigItem) => {
    let isFound = item.confId === confId;
    if (!isFound && adtag) {
      // 如果adtag不为空，那么将`${confId}-${adtag}`作为confId比较
      isFound = item.confId === `${confId}-${adtag}`;
    }
    return isFound;
  });


  const {
    title = '',
    topImg = '',
    bgColor = '',
    btnTop = 0,
    btnText = '',
    btnColor = '', // 默认白色
    actUrl,
    wxAppId,
    wxAppPath,
    wxAppQuery,
  } = business || {};

  // actUrl要进一步处理
  const actUrlFilled = actUrl ? handleActUrl({ actUrl }) : actUrl;

  // urlSchema替换为后端动态获取的
  // const urlSchema = await getUserUrlSchema(actUrlFilled);  // 改为异步获取
  const wxAppQueryFilled = wxAppQuery ? handleActUrl({ actUrl: wxAppQuery, type: 'mp' }) : wxAppQuery;
  return {
    confId,
    title,
    topImg,
    bgColor,
    btnTop: btnTop > 0 ? btnTop : 782, // 默认782
    btnText,
    btnColor,
    actUrl: actUrlFilled,
    wxAppId,
    wxAppPath,
    wxAppQuery: wxAppQueryFilled,
  };
}

/**
 * 将actUrl里search部分的{param}，替换为location.search里的实际param值
 * @param actUrl
 * @returns
 */
export function handleActUrl({ actUrl, type = 'h5' }: { actUrl: string, type?: 'h5' | 'mp' }): string {
  const index = actUrl.indexOf('?');
  if (index < 0 && type === 'h5') {
    // 没有search部分
    return actUrl;
  }
  const actSearch = actUrl.substring(index + 1);
  const currentSearchKV = qs.parse(location.search) as unknown as IKeyValuePair<string>;

  return actUrl.substring(0, index)
    + (type === 'h5' ? '?' : '') // wxAppQuery字段不需要加’?‘
    + parseStrWitchObj(actSearch, currentSearchKV);
}
